/**
 * InDeckSectionSkeleton - Loading skeleton for in-deck section
 *
 * Displays placeholder content while deck card data is loading.
 */
import type { ReactElement } from 'react';

export default function InDeckSectionSkeleton(): ReactElement {
  return (
    <section className="px-6 pb-6">
      <div className="bg-slate/50 border-storm rounded-xl border p-5">
        {/* Section Header */}
        <div className="bg-slate mb-4 h-3 w-24 animate-pulse rounded" />

        {/* Quantity Controls Skeleton */}
        <div className="flex items-center justify-between">
          <div className="bg-slate h-4 w-16 animate-pulse rounded" />
          <div className="flex items-center gap-1">
            <div className="bg-slate h-8 w-8 animate-pulse rounded-lg" />
            <div className="bg-slate h-6 w-10 animate-pulse rounded" />
            <div className="bg-slate h-8 w-8 animate-pulse rounded-lg" />
          </div>
        </div>

        {/* Zone Selector Skeleton */}
        <div className="mt-4 flex items-center justify-between">
          <div className="bg-slate h-4 w-12 animate-pulse rounded" />
          <div className="bg-slate h-9 w-28 animate-pulse rounded-lg" />
        </div>

        {/* Remove Button Skeleton */}
        <div className="bg-slate mt-4 h-9 w-full animate-pulse rounded-lg" />
      </div>
    </section>
  );
}
